const defalutData = {
  subList: {
    month: [
      {
        name: "FREE",
        dsc: "All essential startup features",
        symbol: "$",
        title_icon: "/order_fulfillment/free_icon.png",
        popular: "",
        price: "0.00",
        oldPrice: "",
        date: "Monthly",
        isFree: true,
        type: 1,
        id: 0,
        button: "Downgrade",
        link: "",
        discount: 0,
        discount_time: 0,
        discount_day: 0,
        money: 0,
        loading: false,
        disabled: false,
        level: 0,
        limitation: {
          sourcing_num: 3,
          ali_product_num: 10,
          dsm_product_num: 10,
          temu_product_num: 10,
        },
        common: [],
        dscList: [
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "10 AliExpress Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "10 Temu Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "10 DSM Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Unlimited Orders Fulfillment",
            tip_p: "",
            tip_icon: "",
          },
        ],
      },
      {
        name: "Basic",
        dsc: "All the essentials for a new business",
        symbol: "$",
        id: 4,
        title_icon: "/order_fulfillment/basic_icon.png",
        popular: "",
        price: "9.9",
        oldPrice: "19",
        date: "Monthly",
        isFree: true,
        type: 1,
        button: "Downgrade",
        link: "",
        discount: 0,
        discount_time: 0,
        discount_day: 0,
        money: 9.9,
        loading: false,
        disabled: false,
        level: 0,
        limitation: {
          sourcing_num: 3,
          ali_product_num: 10,
          dsm_product_num: 10,
          temu_product_num: 10,
        },
        common: ["10 Sourcing Requests", "900 Product Imports", "24/7 Support"],
        dscList: [
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "199 points",
            strong: true,
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            tip_icon: "/sub/sub_tip.png",
            p: "10 sourcing requests per month",
            tip_p:
              "After you submit a sourcing request, our product sourcing team will conduct the search and provide a quotation within 1 to 5 days.",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Access to 1M+ Products",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "24/7 Support",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "300 AliExpress Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "300 Temu Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "300 DSM Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Unlimited Orders Fulfillment",
            tip_p: "",
            tip_icon: "",
          },
        ],
      },
      {
        name: "PRO",
        dsc: "All necessary features for growing business",
        symbol: "$",
        id: 1,
        title_icon: "/order_fulfillment/pro_icon.png",
        popular: "",
        price: "29.9",
        oldPrice: "49",
        date: "Monthly",
        isFree: false,
        type: 1,
        button: "Start 7-day free trial",
        link: "",
        discount: 0,
        discount_time: 0,
        discount_day: 0,
        money: 29.9,
        loading: false,
        disabled: false,
        level: 1,
        limitation: {
          sourcing_num: 3,
          ali_product_num: 10,
          dsm_product_num: 10,
          temu_product_num: 10,
        },
        common: [
          "3000 Product Imports",
          "Automatic Product Pricing, Order Sourcing, and Order Fulfillment",
          "Dedicated Manager  Services",
        ],
        dscList: [
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "499 points",
            strong: true,
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "30 sourcing requests per month",
            tip_p:
              "After you submit a sourcing request, our expert sourcing specialists will conduct product searches and provide quotations within 1 to 3 days.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Access to 1M+ Products",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "24/7 VIP Support",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Dedicated Manager Services",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "1000 AliExpress Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "1000 Temu Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "1000 DSM Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Unlimited Orders Fulfillment",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Order Auto Sourcing",
            tip_p: "",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Bulk Product Sourcing",
            tip_p:
              "Supports you to initiate product sourcing for all the products in your store that are currently on sale with just one click, thereby changing the suppliers of the products to Dropshipman.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Automated Fulfillment",
            tip_p:
              "You can set default payment methods and shipping channels, and when orders from your store are synced to Dropshipman, the payment will be automatically completed without the need for manual payment.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Advanced Auto Pricing",
            tip_p: "",
            tip_icon: "/sub/sub_tip.png",
          },
        ],
      },
      {
        name: "PLUS",
        dsc: "Powerful features for scaling your business",
        symbol: "$",
        id: 2,
        title_icon: "/order_fulfillment/plus_icon.png",
        popular: "Recommend",
        price: "49.9",
        oldPrice: "79",
        date: "Monthly",
        isFree: true,
        type: 1,
        button: "Start 7-day free trial",
        link: "",
        discount: 0,
        discount_time: 0,
        discount_day: 0,
        money: 49.9,
        loading: false,
        disabled: false,
        level: 2,
        limitation: {
          sourcing_num: 3,
          ali_product_num: 10,
          dsm_product_num: 10,
          temu_product_num: 10,
        },
        common: [
          "Access to Top-selling Products",
          "Vip Shipping Methods",
          "Full Order Tracking",
        ],
        dscList: [
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "799 points",
            strong: true,
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "60 expert sourcing requests per month",
            tip_p:
              "After you submit a sourcing request, our expert sourcing specialists will conduct product searches and provide quotations within 1 to 3 days.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Access to 1M+ Products",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "24/7 VIP Support",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Dedicated Manager",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "5000 AliExpress Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "5000 Temu Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "5000 DSM Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Access to Winning Products",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Bulk Product Sourcing",
            tip_p: "",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Advanced Auto Pricing",
            tip_p:
              "Supports you to initiate product sourcing for all the products in your store that are currently on sale with just one click, thereby changing the suppliers of the products to Dropshipman.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Order Auto Sourcing",
            tip_p:
              "You can set default payment methods and shipping channels, and when orders from your store are synced to Dropshipman, the payment will be automatically completed without the need for manual payment.",
            tip_icon: "/sub/sub_tip.png",
          },
  
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Automated Fulfillment",
            tip_p:
              "From the moment your order is successfully placed, we create an order tracking process for you that includes order confirmation, product quality inspection, product shipment, and package transportation, allowing you to stay up-to-date with your order in real-time.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Advanced Product Quality Inspection",
            tip_p:
              "Best-selling products carefully selected and recommended by sourcing experts, helping you identify profitable opportunities.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Vip Shipping Methods",
            tip_p:
              "You can set price rules based on the price tiers of the products, and when importing products, the system will automatically set the prices of the products according to the price rules you have set.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Order Tracking",
            tip_p:
              "Once you initiate product sourcing and privatize it, the product can only be sold by you and other customers will not be able to use the product that you have privatized.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Unlimited Orders Fulfillment",
            tip_p:
              "Before shipping the products, we will remove the Chinese characters and labels on the products to provide your customers with a better experience.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Remove China Label",
            tip_p:
              "Before shipping the products, we will remove the Chinese characters and labels on the products to provide your customers with a better experience.",
            tip_icon: "/sub/sub_tip.png",
          },
        ],
      },
  
      {
        name: "PREMIUM",
        dsc: "All Plus features, unlimited product imports, 2990 points, and Personal Agent VIP Services",
        symbol: "$",
        id: 5,
        title_icon: "/order_fulfillment/premium_icon.png",
        popular: "",
        price: "149",
        oldPrice: "199",
        date: "Monthly",
        isFree: true,
        type: 1,
        button: "Downgrade",
        link: "",
        discount: 0,
        discount_time: 0,
        discount_day: 0,
        money: 149,
        loading: false,
        disabled: false,
        level: 0,
        limitation: {
          sourcing_num: 3,
          ali_product_num: 10,
          dsm_product_num: 10,
          temu_product_num: 10,
        },
        common: [
          "Personal Agent Services",
          "Custom Brand Packaging & Cards",
          "Custom Private Storage Solutions",
        ],
        dscList: [
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            tip_icon: "/sub/sub_tip.png",
            p: "All Plus Plan benefits",
            tip_p: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            tip_icon: "/sub/sub_tip.png",
            p: "2990 points",
            tip_p: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            tip_icon: "/sub/sub_tip.png",
            p: "300 priority expert sourcing requests",
            tip_p: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Unlimited product imports",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Full Process Order Follow-up",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Personalized Trend Product Suggestions",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Custom Private Storage Solutions",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Recommended Chinese Factories & Sources",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Best Logistics Route Suggestions",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Rigorous Product Quality Control",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Custom Brand Packaging & Cards",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Custom Product Photography",
            tip_p: "",
            tip_icon: "",
          },
        ],
        agentService: [
          "Custom Brand Packaging & Cards",
          "Custom Private Storage Solutions",
          "Personalized Trend Product Suggestions",
          "Custom Product Photography",
          "Priority Quoting for Sourcing",
          "Rigorous Product Quality Control",
          "Full Process Order Follow-up",
          "Recommended Chinese Factories & Sources",
          "Best Logistics Route Suggestions",
        ],
        agent: [
          {
            name: "Lucy Li",
            img_url: "/dashborard_sale.jpg",
            year: 5,
            rating: 4.9,
            service_tags: ["ssaaad", "adadadllss"],
          },
          {
            name: "Lucy Li",
            img_url: "/dashborard_sale.jpg",
            year: 5,
            rating: 4.9,
            service_tags: ["ssaaad", "adadadllss"],
          },
          {
            name: "Lucy Li",
            img_url: "/dashborard_sale.jpg",
            year: 5,
            rating: 4.9,
            service_tags: ["ssaaad", "adadadllss"],
          },
          {
            name: "Lucy Li",
            img_url: "/dashborard_sale.jpg",
            year: 5,
            rating: 4.9,
            service_tags: ["ssaaad", "adadadllss"],
          },
        ],
      },
    ],
    year: [
      {
        name: "FREE",
        dsc: "All essential startup features",
        symbol: "$",
        title_icon: "/order_fulfillment/free_icon.png",
        popular: "",
        price: "0.00",
        oldPrice: "",
        date: "Monthly",
        isFree: true,
        type: 1,
        id: 0,
        button: "Downgrade",
        link: "",
        discount: 0,
        discount_time: 0,
        discount_day: 0,
        money: 0,
        loading: false,
        disabled: false,
        level: 0,
        limitation: {
          sourcing_num: 3,
          ali_product_num: 10,
          dsm_product_num: 10,
          temu_product_num: 10,
        },
        common: [],
        dscList: [
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "10 AliExpress Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "10 Temu Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "10 DSM Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Unlimited Orders Fulfillment",
            tip_p: "",
            tip_icon: "",
          },
        ],
      },
      {
        name: "Basic",
        dsc: "All the essentials for a new business",
        symbol: "$",
        id: 4,
        title_icon: "/order_fulfillment/basic_icon.png",
        popular: "",
        price: "19.9",
        oldPrice: "19",
        date: "Monthly",
        isFree: true,
        type: 1,
        button: "Downgrade",
        link: "",
        discount: 0,
        discount_time: 0,
        discount_day: 0,
        money: 19.9,
        loading: false,
        disabled: false,
        level: 0,
        limitation: {
          sourcing_num: 3,
          ali_product_num: 10,
          dsm_product_num: 10,
          temu_product_num: 10,
        },
        common: ["120 Sourcing Requests", "10800 Product Imports", "24/7 Support"],
        dscList: [
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "2388 points",
            strong: true,
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            tip_icon: "/sub/sub_tip.png",
            p: "10 sourcing requests per month",
            tip_p:
              "After you submit a sourcing request, our product sourcing team will conduct the search and provide a quotation within 1 to 5 days.",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Access to 1M+ Products",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "24/7 Support",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "300 AliExpress Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "300 Temu Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "300 DSM Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Unlimited Orders Fulfillment",
            tip_p: "",
            tip_icon: "",
          },
        ],
      },
      {
        name: "PRO",
        dsc: "All necessary features for growing business",
        symbol: "$",
        id: 1,
        title_icon: "/order_fulfillment/pro_icon.png",
        popular: "",
        price: "29.9",
        oldPrice: "49",
        date: "Monthly",
        isFree: false,
        type: 1,
        button: "Start 7-day free trial",
        link: "",
        discount: 0,
        discount_time: 0,
        discount_day: 0,
        money: 29.9,
        loading: false,
        disabled: false,
        level: 1,
        limitation: {
          sourcing_num: 3,
          ali_product_num: 10,
          dsm_product_num: 10,
          temu_product_num: 10,
        },
        common: [
          "36000 Product Imports",
          "Automatic Product Pricing, Order Sourcing, and Order Fulfillment",
          "Dedicated Manager  Services",
        ],
        dscList: [
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "5988 points",
            strong: true,
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "30 sourcing requests per month",
            tip_p:
              "After you submit a sourcing request, our expert sourcing specialists will conduct product searches and provide quotations within 1 to 3 days.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Access to 1M+ Products",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "24/7 VIP Support",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Dedicated Manager Services",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "1000 AliExpress Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "1000 Temu Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "1000 DSM Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Unlimited Orders Fulfillment",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Order Auto Sourcing",
            tip_p: "",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Bulk Product Sourcing",
            tip_p:
              "Supports you to initiate product sourcing for all the products in your store that are currently on sale with just one click, thereby changing the suppliers of the products to Dropshipman.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Automated Fulfillment",
            tip_p:
              "You can set default payment methods and shipping channels, and when orders from your store are synced to Dropshipman, the payment will be automatically completed without the need for manual payment.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Advanced Auto Pricing",
            tip_p: "",
            tip_icon: "/sub/sub_tip.png",
          },
        ],
      },
      {
        name: "PLUS",
        dsc: "Powerful features for scaling your business",
        symbol: "$",
        id: 2,
        title_icon: "/order_fulfillment/plus_icon.png",
        popular: "Recommend",
        price: "49.9",
        oldPrice: "79",
        date: "Monthly",
        isFree: true,
        type: 1,
        button: "Start 7-day free trial",
        link: "",
        discount: 0,
        discount_time: 0,
        discount_day: 0,
        money: 49.9,
        loading: false,
        disabled: false,
        level: 2,
        limitation: {
          sourcing_num: 3,
          ali_product_num: 10,
          dsm_product_num: 10,
          temu_product_num: 10,
        },
        common: [
          "Access to Top-selling Products",
          "Vip Shipping Methods",
          "Full Order Tracking",
        ],
        dscList: [
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "9588 points",
            strong: true,
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "60 expert sourcing requests per month",
            tip_p:
              "After you submit a sourcing request, our expert sourcing specialists will conduct product searches and provide quotations within 1 to 3 days.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Access to 1M+ Products",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "24/7 VIP Support",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Dedicated Manager",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "5000 AliExpress Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "5000 Temu Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "5000 DSM Product Import per month",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Access to Winning Products",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Bulk Product Sourcing",
            tip_p: "",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Advanced Auto Pricing",
            tip_p:
              "Supports you to initiate product sourcing for all the products in your store that are currently on sale with just one click, thereby changing the suppliers of the products to Dropshipman.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Order Auto Sourcing",
            tip_p:
              "You can set default payment methods and shipping channels, and when orders from your store are synced to Dropshipman, the payment will be automatically completed without the need for manual payment.",
            tip_icon: "/sub/sub_tip.png",
          },
  
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Automated Fulfillment",
            tip_p:
              "From the moment your order is successfully placed, we create an order tracking process for you that includes order confirmation, product quality inspection, product shipment, and package transportation, allowing you to stay up-to-date with your order in real-time.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Advanced Product Quality Inspection",
            tip_p:
              "Best-selling products carefully selected and recommended by sourcing experts, helping you identify profitable opportunities.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Vip Shipping Methods",
            tip_p:
              "You can set price rules based on the price tiers of the products, and when importing products, the system will automatically set the prices of the products according to the price rules you have set.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Order Tracking",
            tip_p:
              "Once you initiate product sourcing and privatize it, the product can only be sold by you and other customers will not be able to use the product that you have privatized.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Unlimited Orders Fulfillment",
            tip_p:
              "Before shipping the products, we will remove the Chinese characters and labels on the products to provide your customers with a better experience.",
            tip_icon: "/sub/sub_tip.png",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Remove China Label",
            tip_p:
              "Before shipping the products, we will remove the Chinese characters and labels on the products to provide your customers with a better experience.",
            tip_icon: "/sub/sub_tip.png",
          },
        ],
      },
      {
        name: "PREMIUM",
        dsc: "All Plus features, unlimited product imports, 35880 points, and Personal Agent VIP Services",
        symbol: "$",
        id: 5,
        title_icon: "/order_fulfillment/premium_icon.png",
        popular: "",
        price: "149",
        oldPrice: "199",
        date: "Monthly",
        isFree: true,
        type: 1,
        button: "Downgrade",
        link: "",
        discount: 0,
        discount_time: 0,
        discount_day: 0,
        money: 149,
        loading: false,
        disabled: false,
        level: 0,
        limitation: {
          sourcing_num: 3,
          ali_product_num: 10,
          dsm_product_num: 10,
          temu_product_num: 10,
        },
        common: [
          "Personal Agent Services",
          "Custom Brand Packaging & Cards",
          "Custom Private Storage Solutions",
        ],
        dscList: [
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            tip_icon: "/sub/sub_tip.png",
            p: "All Plus Plan benefits",
            tip_p: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            tip_icon: "/sub/sub_tip.png",
            p: "35880 points",
            tip_p: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            tip_icon: "/sub/sub_tip.png",
            p: "300 priority expert sourcing requests",
            tip_p: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Unlimited product imports",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Full Process Order Follow-up",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Personalized Trend Product Suggestions",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Custom Private Storage Solutions",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Recommended Chinese Factories & Sources",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Best Logistics Route Suggestions",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Rigorous Product Quality Control",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Custom Brand Packaging & Cards",
            tip_p: "",
            tip_icon: "",
          },
          {
            icon: "/sub/ok_icon.png",
            icon_next: "/sub/ok_black_icon.png",
            p: "Custom Product Photography",
            tip_p: "",
            tip_icon: "",
          },
        ],
        agentService: [
          "Custom Brand Packaging & Cards",
          "Custom Private Storage Solutions",
          "Personalized Trend Product Suggestions",
          "Custom Product Photography",
          "Priority Quoting for Sourcing",
          "Rigorous Product Quality Control",
          "Full Process Order Follow-up",
          "Recommended Chinese Factories & Sources",
          "Best Logistics Route Suggestions",
        ],
        agent: [
          {
            name: "Lucy Li",
            img_url: "/dashborard_sale.jpg",
            year: 5,
            rating: 4.9,
            tag: ["ssaaad", "adadadllss"],
          },
          {
            name: "Lucy Li",
            img_url: "/dashborard_sale.jpg",
            year: 5,
            rating: 4.9,
            tag: ["ssaaad", "adadadllss"],
          },
          {
            name: "Lucy Li",
            img_url: "/dashborard_sale.jpg",
            year: 5,
            rating: 4.9,
            tag: ["ssaaad", "adadadllss"],
          },
          {
            name: "Lucy Li",
            img_url: "/dashborard_sale.jpg",
            year: 5,
            rating: 4.9,
            tag: ["ssaaad", "adadadllss"],
          },
        ],
      },
    ],
  },
 
};

export default defalutData;